import axios from "axios";
import { API } from "@/lib/api";

const portalApi = axios.create({ baseURL: API });

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("vl_client_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default portalApi;
